// ponytail: <dialog> does the modal work — showModal() for top-layer + backdrop + Esc + focus trap,
// <form method="dialog"> for close, <details name> for the accordion. This only opens it and
// scrolls the nav targets.
if (!customElements.get('guided-steps-questions-dialog')) {
  customElements.define(
    'guided-steps-questions-dialog',
    class GuidedStepsQuestionsDialog extends HTMLElement {
      #listeners = new AbortController();

      connectedCallback() {
        const { signal } = this.#listeners;
        const dialog = this.querySelector('dialog');
        if (!dialog) return;

        this.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('[data-dialog-open]')) {
              dialog.showModal();
              return;
            }

            const navButton = event.target.closest('[data-dialog-nav]');
            if (navButton) this.#goToPanel(navButton);
          },
          { signal }
        );

        // Clicking the backdrop resolves to the dialog itself, never a child.
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        }, { signal });
      }

      disconnectedCallback() {
        this.#listeners.abort();
        this.#listeners = new AbortController();
      }

      #goToPanel(navButton) {
        const panel = this.querySelector(`[data-dialog-panel="${navButton.dataset.dialogNav}"]`);
        if (!panel) return;

        this.querySelectorAll('[data-dialog-nav]').forEach((button) => {
          // aria-current="" reads as false, so set the value or drop the attribute entirely.
          if (button === navButton) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  );
}
